import { createFileRoute } from "@tanstack/react-router";
import { JoinGroupPage } from "@corpuscomplete/web/modules/auth/group/pages/join";

export const Route = createFileRoute("/_authenticated/join/$token")({
  component: JoinGroupPage,
});
